/**
 * Footer
 * Modern with teal accents and subtle gradient
 */

import { Link } from 'react-router-dom';
import Newsletter from './Newsletter';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-surface-subtle to-primary-50 border-t border-border-subtle">
      <div className="page-container py-16 md:py-20">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Link to="/" className="text-h3 font-medium text-text-primary tracking-tight hover:text-primary-600 transition-colors">
              Anvayee
            </Link>
            <p className="mt-4 text-base text-text-secondary max-w-sm leading-relaxed">
              Consulting for tech professionals returning to India.
              Tax planning. Real estate advisory.
            </p>
          </div>

          {/* Navigation Columns */}
          <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Services */}
            <div>
              <h4 className="text-caption font-medium uppercase tracking-wider text-text-tertiary mb-4">
                Services
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/return-to-india" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    Return to India
                  </Link>
                </li>
                <li>
                  <Link to="/real-estate" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    Real Estate
                  </Link>
                </li>
                <li>
                  <Link to="/book" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    Book Consultation
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-caption font-medium uppercase tracking-wider text-text-tertiary mb-4">
                Company
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/about" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    About
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-small text-text-secondary hover:text-primary-600 transition-colors">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-caption font-medium uppercase tracking-wider text-text-tertiary mb-4">
                Contact
              </h4>
              <ul className="space-y-3">
                <li>
                  <a
                    href="mailto:hello@anvayee.com"
                    className="text-small text-text-secondary hover:text-primary-600 transition-colors"
                  >
                    hello@anvayee.com
                  </a>
                </li>
                <li>
                  <span className="text-small text-text-tertiary">
                    Hyderabad, India
                  </span>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <Newsletter variant="inline" source="footer" />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-border">
          <p className="text-small text-text-tertiary">
            &copy; {currentYear} Anvayee Consulting
          </p>
        </div>
      </div>
    </footer>
  );
}
